import { JetView } from 'webix-jet';
import { devConfig, profile } from '../../../config/config';

/**
 * CouponsView class extends JetView to create a form for managing coupons.
 */
export default class CouponsView extends JetView {
    /**
     * Configures the layout of the CouponsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect',
                    name: 'CountryId',
                    id: 'country',
                    localId: 'Country:combo',
                    label: "<span class='icon-language'></span>" + _('País'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [],
                    required: true,
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'richselect',
                    name: 'CurrencyId',
                    id: 'currency',
                    localId: 'Currency:combo',
                    label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [],
                    required: true,
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'combo',
                    name: 'ProductId',
                    localId: 'product:combo',
                    label: _('Producto'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this;
                                if (text.length > 2) {
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/ProductsCouponsSelect',
                                            '{"Filter":"' + text + '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! ');
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text);
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data);
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                    required: true,
                    invalidMessage: _('Campo Requerido'),
                },
                {
                    view: 'text',
                    name: 'Quantity',
                    label: _('Cantidad:'),
                    labelPosition: 'top',
                    placeholder: _('Cantidad:'),
                    required: true,
                    invalidMessage: _('Campo Requerido'),
                    type: 'number',
                },
                {
                    view: 'text',
                    name: 'Value',
                    label: _('Valor:'),
                    labelPosition: 'top',
                    placeholder: _('Valor a Recargar:'),
                    required: true,
                    invalidMessage: _('Campo Requerido'),
                    type: 'number',
                },
            ],
        };
        const upper_section = {
            cols: [{ id: 'grav', gravity: 1 }, left, { id: 'grav1', gravity: 1 }],
        };
        const buttons = {
            margin: 10,
            cols: [
                { id: 'grav2', gravity: 1 },
                {
                    view: 'button',
                    value: _('Enviar'),
                    hotkey: 'enter',
                    type: 'form',
                    id: 'buttonDeposit',
                    click: () => {
                        if ($$('formRecargaCredito').validate()) {
                            var vvthis = this;
                            webix.confirm({
                                type: 'confirm-warning',
                                text: _('Advertencia!') + '<br/>' + _('Desea enviar el cupón?'),
                                ok: _('Enviar'),
                                cancel: _('Salir'),
                                callback: function (action) {
                                    if (action === true) {
                                        const vthis = this;
                                        var item = vvthis.getRoot().getValues();
                                        $$('buttonDeposit').hide();
                                        document.getElementById('loading').style.display = 'block';
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SendCoupon',
                                                '{ "CountryId":' +
                                                    item.CountryId +
                                                    ',"CurrencyId":"' +
                                                    item.CurrencyId +
                                                    '","ProductId":"' +
                                                    item.ProductId +
                                                    '","Quantity":"' +
                                                    item.Quantity +
                                                    '","Value":"' +
                                                    item.Value +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! ');
                                                        document.getElementById('loading').style.display = 'none';
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var dat = JSON.parse(text);
                                                        if (dat.HasError) {
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: _(dat.AlertMessage),
                                                            });
                                                            $$('buttonDeposit').show();
                                                            document.getElementById('loading').style.display = 'none';
                                                        } else {
                                                            document.getElementById('loading').style.display = 'none';
                                                            webix.message(_('Cupón Enviado Satisfactoriamente'));
                                                            $$('buttonDeposit').show();
                                                            vvthis.getRoot().clear();
                                                            const rowsTable = [];
                                                            dat.Data.forEach((item) => {
                                                                rowsTable.push({
                                                                    Id: item,
                                                                });
                                                            });
                                                            const table = {
                                                                view: 'datatable',
                                                                id: 'couponsTable',
                                                                columns: [
                                                                    {
                                                                        id: 'Id',
                                                                        header: _('Códigos'),
                                                                        fillspace: true,
                                                                    },
                                                                ],
                                                                data: rowsTable,
                                                            };
                                                            const buttons = {
                                                                padding: 10,
                                                                cols: [
                                                                    {
                                                                        view: 'button',
                                                                        value: _('Exportar'),
                                                                        hotkey: 'enter',
                                                                        type: 'form',
                                                                        click: () => {
                                                                            webix.toCSV($$('couponsTable'), {
                                                                                filename:
                                                                                    'Virtualsoft - ' +
                                                                                    new Date()
                                                                                        .toLocaleString('en-GB', {
                                                                                            hour12: true,
                                                                                        })
                                                                                        .replace(
                                                                                            /^(\d{4})-(\d{2})-(\d{2})$/g,
                                                                                            '$3/$2/$1',
                                                                                        )
                                                                                        .replace(/[\/:]/g, '_')
                                                                                        .toUpperCase() +
                                                                                    ' - ' +
                                                                                    ($$('couponsTable').count() > 0
                                                                                        ? ''
                                                                                        : _('No hay datos - ')) +
                                                                                    'cupones',
                                                                            });
                                                                        },
                                                                    },
                                                                ],
                                                            };
                                                            webix
                                                                .ui({
                                                                    view: 'window',
                                                                    move: true,
                                                                    id: 'couponsPopup',
                                                                    width: 400,
                                                                    height: 420,
                                                                    fullscreen: screen.width < 500 ? true : false,
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label: _('Cupones'),
                                                                                align: 'center',
                                                                            },
                                                                            {
                                                                                view: 'icon',
                                                                                icon: 'wxi-close',
                                                                                click: function () {
                                                                                    this.getTopParentView().hide();
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                    modal: true,
                                                                    position: 'center',
                                                                    body: {
                                                                        view: 'scrollview',
                                                                        scroll: 'xy',
                                                                        body: {
                                                                            padding: 10,
                                                                            rows: [table, buttons],
                                                                        },
                                                                    },
                                                                })
                                                                .show();
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                },
                            });
                        }
                    },
                },
                { id: 'grav3', gravity: 1 },
            ],
        };
        return {
            view: 'form',
            id: 'formRecargaCredito',
            rows: [upper_section, buttons],
        };
    }

    /**
     * Initializes the CouponsView, setting up event listeners and loading initial data.
     * @param {Object} form - The form instance.
     */
    init(form) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide();
                $$('grav1').hide();
                $$('grav2').hide();
                $$('grav3').hide();
            }
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! ');
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'));
                        var optionsProvinceRegions = $$('country').getList();
                        optionsProvinceRegions.clearAll();
                        optionsProvinceRegions.parse(data.Data);
                    },
                });
            $$('country').attachEvent('onChange', function (newv, oldv) {
                var optionscountries = this.getList().getItem(newv);
                var optionscurrencies = $$('currency').getList();
                optionscurrencies.clearAll();
                if (optionscountries != undefined) {
                    optionscurrencies.parse(optionscountries.currencies);
                }
            });
        });
        var vthis = this;
        const _ = this.app.getService('locale')._;
    }
}

// FILE DOCUMENTED
